import Vue from 'vue';
import accountService from '../../services/account';

const success = async (context, response) => {
  accountService.getUserWithStatuses(context);
  toastr.success(context.$t('status_update_success'));
};

const failed = (context, error) => {
  toastr.error("Something went wrong");
};

export default (context, data) => {
  return Vue.$http.put('update-booking-status', data)
    .then(response => {
      if (response && response.status === 200) {
        success(context, response);
      }
    }).catch(error => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking_status/updateBookingStatus.js